"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _button = require("@alicd/next/lib/button");

var _button2 = _interopRequireDefault(_button);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _grid = require("@alicd/next/lib/grid");

var _grid2 = _interopRequireDefault(_grid);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = _grid2.default.Row,
    Col = _grid2.default.Col;

var PopupConfirm = function (_React$Component) {
    (0, _inherits3.default)(PopupConfirm, _React$Component);

    function PopupConfirm(props) {
        (0, _classCallCheck3.default)(this, PopupConfirm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PopupConfirm.__proto__ || (0, _getPrototypeOf2.default)(PopupConfirm)).call(this, props));

        _this.handleOk = _this.handleOk.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PopupConfirm, [{
        key: "setStateAsync",
        value: function setStateAsync(updater) {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _this2.setState(updater, function () {
                    return resolve();
                });
            });
        }
    }, {
        key: "handleOk",
        value: function handleOk(e) {
            typeof this.props.onOk == "function" && this.props.onOk(e);
            this.props.canCloseByOk && this.refs.balloon && this.refs.balloon._onClose(e);
        }
    }, {
        key: "handleCancel",
        value: function handleCancel(e) {
            if (typeof this.props.onCancel == "function") {
                this.props.onCancel(e);
            }
            this.props.canCloseByCancel && this.refs.balloon && this.refs.balloon._onClose(e);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                style = _props.style,
                trigger = _props.trigger,
                closable = _props.closable,
                type = _props.type,
                onOk = _props.onOk,
                onCancel = _props.onCancel,
                canCloseByOk = _props.canCloseByOk,
                canCloseByCancel = _props.canCloseByCancel,
                locale = _props.locale,
                children = _props.children,
                rest = (0, _objectWithoutProperties3.default)(_props, ["className", "style", "trigger", "closable", "type", "onOk", "onCancel", "canCloseByOk", "canCloseByCancel", "locale", "children"]);


            return _react2.default.createElement(
                _balloon2.default,
                (0, _extends3.default)({
                    className: (0, _classnames2.default)("cn-okpopup-overlay", className),
                    style: style,
                    triggerType: "click",
                    alignment: "edge",
                    align: "tr",
                    type: type,
                    closable: closable,
                    trigger: trigger,
                    ref: "balloon"
                }, rest),
                _react2.default.createElement(
                    "div",
                    { className: "cn-okpopup-content" },
                    children
                ),
                _react2.default.createElement(
                    "div",
                    { className: "cn-okpopup-footer" },
                    _react2.default.createElement(
                        _button2.default,
                        { className: "cn-okpopup-btn cn-okpopup-btn-ok", shape: "warning", size: "small", onClick: this.handleOk },
                        locale.ok
                    ),
                    _react2.default.createElement(
                        _button2.default,
                        { className: "cn-okpopup-btn cn-okpopup-btn-cancel", size: "small", onClick: this.handleCancel },
                        locale.cancel
                    )
                )
            );
        }
    }]);
    return PopupConfirm;
}(_react2.default.Component);

PopupConfirm.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    type: _propTypes2.default.oneOf(["normal", "primary"]),
    closable: _propTypes2.default.bool,
    canCloseByOk: _propTypes2.default.bool,
    canCloseByCancel: _propTypes2.default.bool,

    trigger: _propTypes2.default.any,
    onOk: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
};
PopupConfirm.defaultProps = {
    type: "normal",
    closable: false,
    canCloseByOk: true,
    canCloseByCancel: true
};
exports.default = PopupConfirm;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-popup-confirm@0.0.2@@alicd/crui-popup-confirm/lib/PopupConfirm.js
// module id = 656
// module chunks = 0